<template>
  <article id="UiLayer">
    <header>
      <div>
        <Logo @closeNavigation="closeNavigation"></Logo>
        <NavigationButton
          :navigationOpen="navigationOpen"
          @toggleNavigation="toggleNavigation"
        ></NavigationButton>
      </div>

      <transition name="navigationAnimation">
        <Navigation
          v-show="navigationOpen"
          @toggleNavigation="toggleNavigation"
        ></Navigation>
      </transition>
    </header>
    <BackButton @closeNavigation="closeNavigation"></BackButton>
  </article>
</template>
<script>
import Logo from "../ui/Logo.vue";
import NavigationButton from "../ui/NavigationButton.vue";
import Navigation from "../ui/Navigation.vue";
import BackButton from "../ui/BackButton.vue";

export default {
  name: "UiLayer",
  components: {
    // Ui Components
    Logo,
    Navigation,
    NavigationButton,
    BackButton
  },
  data() {
    return {
      navigationOpen: false,
    };
  },
  methods: {
    toggleNavigation() {
      this.navigationOpen = !this.navigationOpen;
    },
    closeNavigation() {
      this.navigationOpen = false;
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/sass/_responsiveness.scss';

#UiLayer {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;

  header {
    display: flex;
    justify-content: center;
    pointer-events: none;

    & > div {
      max-width: var(--header-max-width);
      padding: var(--content-padding);
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      height: 68px;
      width: 100%;
      pointer-events: none;
    }
  }

  * {
    pointer-events: all;
  }

  @include tablet-down {
    header {
      &>div {
        height: 45px;
      }
    }
  }
}

.navigationAnimation-enter-active,
.navigationAnimation-leave-active {
  transition-timing-function: ease;
  transition-duration: 0.2s;
  transition-property: opacity;
}

.navigationAnimation-enter-from {
  opacity: 0;
}

.navigationAnimation-leave-to {
  opacity: 0;
}
</style>